import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ProductGroupReferences } from '@product/const';
import { encodeUid } from '@shared/helpers';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type GroupReferencesState = ProductState['groupReferences'];

export const getGroupReferencesState: MemoizedSelector<StateWithProduct, GroupReferencesState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.groupReferences,
);

export const getGroupReferences = (
  productCode: string,
  referenceType: string,
): MemoizedSelector<StateWithProduct, StateUtils.LoaderState<ProductGroupReferences[]>> =>
  createSelector(getGroupReferencesState, (state: GroupReferencesState) =>
    StateUtils.entityLoaderStateSelector<ProductGroupReferences[]>(state, encodeUid(productCode, referenceType)),
  );

export const getGroupReferencesValue = (
  productCode: string,
  referenceType: string,
): MemoizedSelector<StateWithProduct, ProductGroupReferences[]> =>
  createSelector(getGroupReferencesState, (state: GroupReferencesState) =>
    StateUtils.entityValueSelector<ProductGroupReferences[]>(state, encodeUid(productCode, referenceType)),
  );

export const getGroupReferencesLoading = (
  productCode: string,
  referenceType: string,
): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getGroupReferencesState, (state: GroupReferencesState) =>
    StateUtils.entityLoadingSelector<ProductGroupReferences[]>(state, encodeUid(productCode, referenceType)),
  );

export const getGroupReferencesError = (
  productCode: string,
  referenceType: string,
): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getGroupReferencesState, (state: GroupReferencesState) =>
    StateUtils.entityErrorSelector<ProductGroupReferences[]>(state, encodeUid(productCode, referenceType)),
  );

export const getGroupReferencesSuccess = (
  productCode: string,
  referenceType: string,
): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getGroupReferencesState, (state: GroupReferencesState) =>
    StateUtils.entitySuccessSelector<ProductGroupReferences[]>(state, encodeUid(productCode, referenceType)),
  );
